import { differenceInDays } from 'date-fns'

type Validity = 'valid' | 'barelyValid' | 'invalid'

export default function certificateValidity(until: Date | null | undefined): { validity: Validity; daysLeft: number } {
  const now = new Date()

  if (!until) {
    return { validity: 'valid', daysLeft: 0 }
  }

  const diff = differenceInDays(until, now)

  if (diff < 0) {
    return { validity: 'invalid', daysLeft: 0 }
  }

  if (diff <= 60) {
    return { validity: 'barelyValid', daysLeft: diff }
  }

  return { validity: 'valid', daysLeft: diff }
}
